module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAFCAYAAABIHbx0AAAAAXNSR0IArs4c6QAAAHNJREFUGBlj1NDQ2MHIyGjLgAMwMTFpcnBwfAOChziUgITPsgCJaiAWBPGwAVFR0VefP3/+C5TzxyYPEgNa9gmXHMnijECvTQJ6zRCXTqBtoaysrD9+/vy5GZcaoPgNFqAhx4CMJ7gU8fDwfAMa9puAQc8BJSodfT4xFtMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart5-icon/Missed Meal.png
// module id = 309
// module chunks = 7